import { jsx as _jsx } from "react/jsx-runtime";
import { useAetherContext } from '#pplx/frontend/aether/components/AetherProvider/useAetherContext.js';
import { DropdownMenuPrimitive } from '#pplx/frontend/aether/primitives/DropdownMenuPrimitive/index.js';
import { Root } from '@radix-ui/react-separator';
export const MENU_SEPARATOR_CLASS_NAME = 'border-soft my-1 mx-2 border-t first:hidden last:hidden';
export function MenuSeparator() {
    const { isMobileStyle } = useAetherContext();
    if (isMobileStyle) {
        return _jsx(Root, { className: MENU_SEPARATOR_CLASS_NAME });
    }
    return _jsx(DropdownMenuPrimitive.Separator, { className: MENU_SEPARATOR_CLASS_NAME });
}
//# sourceMappingURL=MenuSeparator.js.map